<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <slot name="activator" dark :attrs="attrs" :on="on">
        <v-btn color="primary" dark v-bind="attrs" v-on="on">
          Open Dialog
        </v-btn>
      </slot>
    </template>
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Confirm action</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col col="12">
              <h3>
                {{ this.currentState == "blocked" ? "Unblock" : "Block" }} this
                business - <b>{{ business.name }}</b
                >?
                <!-- Please make sure you have collected a payment of
                <strong>{{ yearlyPriceCurrency }} {{ yearlyPrice }}</strong>
                from this business -->
              </h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col col="12">
              <v-text-field
                label="Notes"
                color="primary"
                type="text"
                v-model="notes"
                prepend-icon="mdi-note"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">
          Close
        </v-btn>
        <v-btn color="blue darken-1" v-if="currentState=='unblocked'" text @click="confirmBlockBusiness">
          Confirm Block
        </v-btn>
        <v-btn color="blue darken-1" v-if="currentState=='blocked'" text @click="confirmUnblockBusiness">
          Confirm Unblock
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import config from "../../config/config";

export default {
  props: {
    business: {
      type: Object,
      required: true,
    },
    currentState: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      enteredEmail: "",
      notifications: false,
      sound: true,
      widgets: false,
      rules: [
        (value) => !!value || "Required.",
        (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      ],
      selectedDiscountCode: null,
      selectedPeriod: "1 year",
      notes: "",
    };
  },
  computed: {
    ...mapGetters({
      activeAccount: "partner/active",
    }),
    yearlyPrice() {
      return 1990;
    },
    yearlyPriceCurrency() {
      return "SAR";
    },
    isWhitelabel() {
      return !!config.whitelabelMode;
    },
  },
  methods: {
    ...mapActions({
      fetchBusinesses: "business/fetchBusinesses",
      blockBusiness: "business/blockBusiness",
      unblockBusiness: "business/unblockBusiness",
    }),
    async confirmBlockBusiness() {
      this.dialog = false;
      try {
        this.$notifier.showMessage({
          content: "Blocking..Please wait...",
        });
        await this.blockBusiness({
          accountId: this.activeAccount.id,
          business: this.business,
          notes: this.notes,
        });
        this.$notifier.showMessage({
          content: "Blocked the business",
        });
        this.fetchBusinesses({
          activeAccount: this.activeAccount,
          bid: null,
          options: null,
      });
      } catch (error) {
        this.$notifier.showMessage({
          content:
            "Blocking the business failed. Error: " + error.message ||
            "unknown",
        });
      }
    },
    async confirmUnblockBusiness() {
      this.dialog = false;
      try {
        this.$notifier.showMessage({
          content: "Unblocking..Please wait...",
        });
        await this.unblockBusiness({
          accountId: this.activeAccount.id,
          business: this.business,
          notes: this.notes,
        });
        this.$notifier.showMessage({
          content: "Unblocked the business",
        });
        this.fetchBusinesses({
          activeAccount: this.activeAccount,
          bid: null,
          options: null,
        });
      } catch (error) {
        this.$notifier.showMessage({
          content:
            "Unblocking the business failed. Error: " + error.message ||
            "unknown",
        });
      }
    },
  },
};
</script>
